export function getConfig(urls, cachingLifeTime?) {
  return {
    api: Object.assign({
      caching: {
        lifetime: cachingLifeTime !== undefined ? cachingLifeTime : 30 * 1000// 5 sec
      }
    }, getApiConfig(urls))
  };
}

export function getApiConfig({ baseApiUrl, oldDevApi }) {
  return {
    users: {
      host: `${baseApiUrl}`,
      current: `/auth/user`,
      current_user: '/users/current',
      current_invoiceInfo: `/users/current/invoice-info/`,
      delivery_addresses: '/users/current/delivery-addresses',
      delivery_addresses_one: '/users/current/delivery-addresses/:deliveryAddressId',
      delivery_addresses_favorite: '/users/current/delivery-addresses/:deliveryAddressId/is-favourite',
      import_reminders: '/users/current/reminder-groups/:reminderGroupId/bunch-date-reminders',
      password: '/users/current/password',
      login: `/auth/login`,
      logout: `/auth/logout`,
      register: `/auth/register`,
      restore_password: `/auth/reset-password`,
      restore_password_request: `/auth/reset-password-request`,
      orders: `/users/current/orders`,
      reminderCalendars: `/users/current/reminder-groups`,
      reminderCalendars_one: `/users/current/reminder-groups/:calendarId`,
      reminderCalendars_one_reminders: `/users/current/reminder-groups/:calendarId/date-reminders`,
      reminderCalendars_one_reminders_one: `/users/current/reminder-groups/:calendarId/date-reminders/:reminderId`,
      activate_by_payment_sid: '/auth/activate-by-payment-sid/:sid',
    },
    products: {
      host: `${baseApiUrl}`,
      product_types: `/store/product-types/`,
      product_types_one: `/store/product-types/:id/`,
      product_types_upsell_products_one: `/store/product-types/:id/upsell-products/`,
      product_types_one_closest_delivery_date: `/store/product-types/:id/closest-delivery-date/`,
      product_types_filters: `/store/product-types/filters/`,
      product_types_allergens: `/store/product-types/filters/allergens/`
    },
    bakery: {
      host: `${baseApiUrl}/store`,
      bakeries: `/bakeries/`,
      help_local_bakeries: `/bakeries/for-help-local/`,
      bakery_by_name: `/bakeries/:refName/`,
      bakery_by_id: `/bakeries/:id/`,
      delivery_info: `/bakeries/:id/delivery-info/`,
      delivery_schedule_overrides: `/bakeries/:pk/delivery-zones/:post-code/schedule-overrides/`,
      outlet_schedule_overrides: `/bakeries/:pk/outlets/:outlet_id/schedule-overrides/`,
      outlets: `/bakeries/:id/outlets/`,
      outlets_one_calendar: `/bakeries/:bakeryId/outlets/:outletId/calendar/`,
      deliver_agents_calendar: `/bakeries/:bakeryId/delivery-agents/calendar/`,
      delivery_prices: '/bakeries/:bakeryId/delivery-prices/',
      bakeries_by_city_post_number: '/cities/:cityName/bakeries/',
      bakeries_outlets: '/bakeries/outlets/',
      delivery_by_location: '/bakeries/delivery-by-location/',
      bakeries_search: '/bakeries/search/',
      bakeries_categories: `/bakeries/:id/categories`
    },
    outlet: {
      host: `${baseApiUrl}`,
      outlets: `/store/outlets/`,
      outlet_calendar: '/store/outlet-calendar/'
    },
    common: {
      host: `${baseApiUrl}`,
      keywords: '/store/keywords/',
      country_areas: '/store/areas/:countryCode'
    },
    landing_pages: {
      host: `${baseApiUrl}`,
      landing_pages_slug: '/store/landing-pages/:slug/',
      landing_pages_keywords: '/store/landing-pages/:landingPageId/keywords/',
      product_type: '/store/landing-pages/:landingPageId/product-types/',
      landing_pages_many: '/store/landing-pages/'
    },
    location: {
      host: `${baseApiUrl}`,
      gmaps_places_autocomplete: '/location/gmaps/places-autocomplete',
      location_info: '/location/info',
    },
    extra: {
      host: `${baseApiUrl}`,
      images: `/store/images/`,
      convert_heic: `/store/images/convert-heic`
    },
    cart: {
      host: `${baseApiUrl}/store/cart`,
      cart: `/`,
      promo: `/promo-code/`,
      cart_delivery: `/delivery-order/`,
      delivery_calendar: '/delivery-calendar/',
      outlet_calendar: '/outlet-calendar/',
      returnable_items_outlet_calendar: '/outlet-schedule-calendar/',
      returnable_items_delivery_calendar: '/delivery-schedule-calendar/',
      order_lines_one: `/order-lines/:clientId/`,
      order_lines: `/order-lines/`,
      delivery_info: `/delivery-info`,
      daily_stock_sold_out: '/daily-stock-sold-out/',
      apply_company_discount: `/apply-company-discount`,
      apply_company: `/apply-company`,
      available_time: `/external-delivery/available-time/`,
      delivery_fee: `/external-delivery/delivery-fee/`,
      external_calendar: `/external-delivery/calendar/`,
    },
    city: {
      host: `${baseApiUrl}`,
      cities: '/store/cities/',
      city_by_name: '/store/cities/:refName/',
      city_by_post_number: '/location/countries/:countryCode/post-number/:postNumber'
    },
    orders: {
      host: `${baseApiUrl}`,
      order_one: `/store/orders/:orderId`,
      receipt_url: `/store/orders/:bakeryOrderId/receipt`,
      delivery_order: `/store/orders/:orderId/delivery-order`,
      bakery_delivery_info: `/orders/:orderId/bakery-delivery-info`,
      outlet_calendar: `/store/orders/:orderId/outlet-calendar`,
      delivery_calendar: `/store/orders/:orderId/delivery-calendar`,
    },
    company: {
      host: `${baseApiUrl}/store/companies`,
      companies: '/',
      companies_search: '/search'
    },
    payments: {
      host: `${baseApiUrl}`,
      byName: '/store/payments/:name/',
      extra: '/orders/:orderId/payments/:paymentMethodName/extra/',
      cancel_payment: '/payments/:id/cancel',
      payment_intent_by_token: '/store/payments/intents/:token',
      payment_status: '/store/payments/:sid/status',
    },
    gift_cards: {
      host: `${baseApiUrl}`,
      integration_state: `/store/giftcards/integration-state`,
      gift_card_by_code: `/store/giftcards/:code`,
    },
    categories: {
      host: `${baseApiUrl}`,
      categories_by_ref_name: '/store/:refName/categories'
    },
    store: {
      host: `${baseApiUrl}`,
      feedback: '/store/emails/feedback',
    },
    offers: {
      host: `${baseApiUrl}`,
      offers_one: `/store/offers/:offerId`,
    },
    messages: {
      host: `${baseApiUrl}`,
      order_mark_read: '/store/offers/:orderId/messages/mark-read/',
      order_chat_messages: '/store/offers/:orderId/messages',
    },
    session: {
      host: `${baseApiUrl}/store/sessions/`,
      current: ''
    },
    options: {
      withCredentials: true
    },
  };
}

